export const IDENTITY_TYPE = [
  { id: 1, label: 'KTP' },
  { id: 2, label: 'Kitas' },
  { id: 3, label: 'Paspor' },
];

export const HEALTH_STATUS = [
  { id: 1, label: 'Fit' },
  { id: 2, label: 'NonFit' },
  { id: 3, label: 'Fit with Note' },
];

export const DEPARTMENTS = [
  { id: 1, label: 'Project Management' },
  { id: 2, label: 'Engineering' },
  { id: 3, label: 'Procurement' },
];

export const POSITIONS = [
  { id: 1, label: 'Manager' },
  { id: 2, label: 'Koordinator' },
  { id: 3, label: 'HSE' },
  { id: 99, label: 'Lainnya' },
];

//not using this options anymore since it's on db right now
export const EDUCATIONS = [
  { id: 1, label: "SD" },
  { id: 2, label: "SMP" },
  { id: 3, label: "SMA" },
  { id: 4, label: "D3" },
  { id: 5, label: "S1/D4" },
  { id: 6, label: "S2" },
  { id: 7, label: "S3" },
  { id: 99, label: "Lainnya" },
];

export const PROJECT_DIVISIONS = [
  { id: 1, label: 'Gedung' },
  { id: 2, label: 'Infra 1' },
  { id: 3, label: 'Infra 2' },
];